import {Box, capitalize, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {
  HiristVideoCall,
  HiristTelephonic,
  HiristFace2Face,
} from '@jobseeker/lotus/assets/icons';

type InterviewTypeProps = {
  type: string;
  isAboveLarge: boolean;
};

const InterviewType = ({type, isAboveLarge}: InterviewTypeProps) => {
  const interviewTypeIconMapping = {
    'Face to face': HiristFace2Face,
    Video: HiristVideoCall,
    Telephonic: HiristTelephonic,
  };

  const interviewType = capitalize(
    type.toLowerCase()
  ) as keyof typeof interviewTypeIconMapping;

  return (
    <>
      <Box display="flex" alignItems="center" gap={1}>
        <Image
          src={interviewTypeIconMapping[interviewType]}
          alt="interview-type-icon"
          height={16}
          width={16}
        />
        <Typography
          fontWeight={400}
          fontSize={isAboveLarge ? 14 : 10}
          lineHeight={isAboveLarge ? '20px' : '12px'}
        >
          {!isAboveLarge && 'Interview Type:'}
          {interviewType}
        </Typography>
      </Box>
    </>
  );
};

export default InterviewType;
